module.exports = __webpack_public_path__ + "img/Image_01.67c98488.jpg";